'use client';

import { useTranslations } from 'next-intl';

import DeleteIcon from '@/assets/svg/delete.svg';

interface ISearchHistoryPanelProps {
    keywords: string[];
    onClear: () => void;
    onPick: (keyword: string) => void;
}

export default function SearchHistoryPanel(props: ISearchHistoryPanelProps) {
    const { keywords, onClear, onPick } = props;
    const t = useTranslations('Discover');

    if (keywords.length === 0) {
        return null;
    }

    return (
        <section className='w-[343px]'>
            {/* 历史记录标题与清空 */}
            <div className='mb-[12px] flex h-[24px] w-full items-center justify-between'>
                <h2 className='font-poppins-medium text-[14px] leading-[20px] text-[#111827]'>
                    {t('search_history_title')}
                </h2>
                <button
                    type='button'
                    aria-label={t('search_history_clear_aria')}
                    className='flex size-[24px] shrink-0 items-center justify-center'
                    onClick={onClear}
                >
                    <span className='size-[20px]'>
                        <DeleteIcon color='#B5B5B5' />
                    </span>
                </button>
            </div>

            {/* 历史关键词列表（最多展示 3 行，超出裁剪） */}
            <ul className='flex max-h-[112px] w-full flex-wrap gap-[8px] overflow-hidden'>
                {keywords.map(kw => (
                    <li key={kw} className='min-w-0 max-w-[calc(50%-4px)] shrink-0'>
                        <button
                            type='button'
                            className='box-border flex h-[32px] w-max max-w-full items-center overflow-hidden rounded-[8px] bg-[#F3F3F3] px-[12px] text-left font-poppins-medium text-[12px] leading-[16px]'
                            onClick={() => onPick(kw)}
                        >
                            <span className='min-w-0 max-w-full truncate text-[#888888]'>{kw}</span>
                        </button>
                    </li>
                ))}
            </ul>
        </section>
    );
}
